/**
 * EmbeddedChrome — context flag set by container shells (e.g. HubShell) that
 * embed full pages as tabs. When true:
 *   - PageHeader collapses to a slim toolbar (actions/tabs only — the host
 *     shell already renders the page title)
 *   - PageContainer drops its own scroll region and paper background (the
 *     host owns scrolling)
 * This lets one page component serve both standalone and embedded mounts
 * without prop drilling.
 */
import { createContext, useContext } from 'react'

export const EmbeddedChrome = createContext(false)

export function useEmbeddedChrome(): boolean {
  return useContext(EmbeddedChrome)
}
